import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Expert } from 'src/app/models/expert.schema';
import { RefundRequest, RefundRequestStatus, RefundRequestStatusAux } from 'src/app/models/refund-request.schema';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { ExpertService } from 'src/app/services/expert.service';
import { RefundRequestsService } from 'src/app/services/refund-requests.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-valet-payments',
  templateUrl: './valet-payments.component.html',
  styleUrls: ['./valet-payments.component.scss']
})
export class ValetPaymentsComponent implements OnInit {

  activeAccordionActivityIndex: number | null = null;
  refundRequests: RefundRequest[] = [];
  disableBtn: boolean = false;
  refundStatus = RefundRequestStatus;
  refundStatusAux = RefundRequestStatusAux;
  filtered = {};
  paymentsFilterForm: any;
  selected = "active";
  defaultDeliveryOrder = { 'RefundRequests.id': 'DESC' };
  selectedExpertId: number;
  requestStatus: string = null;
  selectedValet: Expert;
  experts: Expert[] = [];

  constructor(
    private refundRequestsService: RefundRequestsService,
    private commanUsesService: CommanUsesService,
    private route: ActivatedRoute,
    private spinnerService: SpinnerService,
    private expertService: ExpertService,
    private router: Router,
  ) { 
    this.selected = !this.route.snapshot.data['active'] ? 'inactive' : 'active';
  }

  async ngOnInit() { 
    try {
      this.managePaymentsFilterForm();
      await this.getExperts();
      this.route.queryParams.subscribe(async (params) => {
        if (params['expertId']) {
          this.selectedExpertId = +params['expertId'];
          this.selectedValet = this.experts.find(v => v.id === this.selectedExpertId);
        }

        await this.initFilter();
        await this.getAllRefundRequests();
      });
    } catch (error) {
      this.commanUsesService.showSnackBar(error?.error?.message);
    }
  }

  managePaymentsFilterForm(){
    this.paymentsFilterForm = new FormGroup({
      'RefundRequests.requestStatus': new FormControl(),
    });
  }

  async initFilter() {
    this.filtered = {};
    this.filtered['RefundRequests.expertId'] = this.selectedExpertId;

    if (this.requestStatus) {
      this.filtered['RefundRequests.requestStatus'] = {
        operator: 'like',
        values: [`%${this.requestStatus}%`],
      };
    } else {
      const availableStatuses = this.selected === 'active'
        ? RefundRequestStatusAux.active
        : RefundRequestStatusAux.inactive;

      this.filtered['RefundRequests.requestStatus'] = {
        operator: 'in',
        values: availableStatuses,
      };
    }
  }

  async initialize() {
    await this.getAllRefundRequests();
  }

  toggleAccordion(index?: number){
    if (this.activeAccordionActivityIndex === index) {
      this.activeAccordionActivityIndex = null;
    } else {
      this.activeAccordionActivityIndex = index; 
    }
  }

  async getAllRefundRequests(){
    try {
      if(this.selectedExpertId) {
        this.refundRequests = await this.refundRequestsService.getAllRefundRequests(1, 1000, this.defaultDeliveryOrder, this.filtered);
      }
    } catch (error) { }
  }

  async handleApproveClick(refundRequest: RefundRequest, event: MouseEvent) {
    try {
      event.stopPropagation();
      if (!confirm("Are you sure? Requested plus will add on valet's plus minus salary")) return;

      this.disableBtn = true;
      let promise = this.refundRequestsService.approveSalaryRefund(refundRequest.id);

      promise.then(async (response: RefundRequest) => {
        this.disableBtn = false;
        if(response.id) {
          this.commanUsesService.showSnackBar('Refund Request has been approved');
        }
        await this.getAllRefundRequests();
      }).catch((error) => {
        this.disableBtn = false;
        this.commanUsesService.showSnackBar(`${error?.error?.message}`);
      });
      
    } catch (error) {
      this.disableBtn = false;
      this.commanUsesService.showSnackBar(`${error?.error?.message}`);
    }
  }

  async handlePaidClick(refundRequest: RefundRequest, event: MouseEvent){
    try {
      event.stopPropagation();
      
      if (!confirm("Are you sure? This will set as paid.")) return;

      this.disableBtn = true;
      let promise = this.refundRequestsService.paidSalaryRefund(refundRequest.id);

      promise.then(async (response: RefundRequest) => {
        this.disableBtn = false;
        if(response.id) {
          this.commanUsesService.showSnackBar('Refund Request has been paid.');
        }
        await this.getAllRefundRequests();
      }).catch((error) => {
        this.disableBtn = false;
        this.commanUsesService.showSnackBar(`${error?.error?.message}`);
      });

    } catch (error) {
      this.disableBtn = false;
      this.commanUsesService.showSnackBar(`${error?.error?.message}`);
    }
  }

  async handleValetChange(valetId: number) {
    try {
      this.spinnerService.show();
      this.selectedValet = this.experts.find(v => v.id === Number(valetId));
      this.selectedExpertId = this.selectedValet?.id;
      await this.initFilter();

      this.router.navigate([], {
        queryParams: { expertId: this.selectedExpertId },
        queryParamsHandling: 'merge'
      });

      await this.getAllRefundRequests();
      this.spinnerService.hide();
    } catch (error) {
      console.error("ERROR", error);
    }
  }

  async handleRefundRequestChange() {
    try {
      this.spinnerService.show();
      await this.initFilter();
      await this.getAllRefundRequests();
      this.spinnerService.hide();
    } catch (error) {
      console.error("ERROR", error);
    }
  }
         

  async getExperts(){
    this.experts = await this.expertService.getAllActiveExpertsForDelivery().then(res => res.experts);
  }

  openReceiptInNewTab(url: string) {
    window.open(url, '_blank');
  }


}
